
<div class="shopSearch">
  <search-result :pager="pager" :shops="shops" :pr_shops="pr_shops" :waiting="form.waiting" @next="search" />
</div>
